import {appURLS} from "appRoot/app.constants";
import { AxiosInstance, AxiosPromise } from 'axios';
import AdminService from "external-services/diary-admin-service/admin.service";
import DateUtilsService from "external-services/date-utils-service";
import NetworkRequestsService from 'external-services/network-requests-service';

const NS = 'ForecastReportService'; // jshint ignore:line
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();

interface IService {
  $$hashKey: string;
  name: string;
  price: number;
}

interface IForecastValue {
  bookings: number;
  bookingCovers: number;
  walkIns: number;
  walkInCovers: number;
  totalRevenue: number;
}
interface IForecastData  {
  date: string;
  weekday: string;
  forecastData: {
    serviceName: string;
    historic: IForecastValue;
    present: IForecastValue;
    future: IForecastValue;
  }[];
  historicTotal: IForecastValue;
  presentTotal: IForecastValue;
  futureTotal: IForecastValue;
}
class ForecastReportService{

  public getServices(forecastDate: Date): AxiosPromise<{data: string[]}> {
    const venueId = AdminService.getVenue().id;

    return api.get(appURLS.API + '/restaurants/venues/' + venueId + '/forecast-services?forecastDate=' + DateUtilsService.dateToIdStr(forecastDate));
  }

  public getReport(forecastDate: Date, from: Date, to: Date, services: IService[]): AxiosPromise<{data: IForecastData[]}> {
    const venueId = AdminService.getVenue().id;
    const data = {
      forecastDate: DateUtilsService.dateToIdStr(forecastDate),
      from: DateUtilsService.dateToIdStr(from),
      to: DateUtilsService.dateToIdStr(to),
      servicePrices: services
    };
    return api.post(appURLS.API + '/restaurants/venues/' + venueId + '/forecast-report', data);
  }
}

const instance = new ForecastReportService();
export default instance as ForecastReportService;
